<template>
  <div v-loading="loading">
    <pt-assigned-tasks-form :notesDetail="notesDetail" :userDetail="userDetail" ref="form" class="pt-assigned-tasks-form__withData"></pt-assigned-tasks-form>
    <div>
      <el-button @click="submit" type="primary">确定</el-button>
      <el-button @click="cancel" type="primary" plain>取消</el-button>
    </div>
  </div>
</template>

<script>
import PtAssignedTasksForm from './index'
export default {
  name: 'pt-assigned-tasks-form__withData',
  components: {
    'pt-assigned-tasks-form': PtAssignedTasksForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  data () {
    return {
      loading: false,
      notesDetail: {},
      recordId: this.$route.params.recordId,
      userDetail: {}
    }
  },
  methods: {
    submit () {
      this.form.validate().then(formValue => {
        let data = {
          unscramblePerson: formValue.unscramblePerson,
          registrationId: formValue.recordData[0].id
        }
        this.$store.dispatch('changeAllotUser', data).then(res => {
          this.$message.success('分配任务成功')
          history.go(-1)
        }).catch(errorMessage => {
          this.$emit('submitLoading', false)
          this.$message.error(errorMessage || '分配任务失败')
        })
      })
    },
    cancel () {
      history.go(-1)
    },
    signNotesDetail () {
      this.$store.dispatch('signNotesDetail', this.recordId).then(res => {
        this.notesDetail = res
        if (this.notesDetail.allotUserName) {
          this.getUserDetail(this.notesDetail.allotUserId)
        }
        console.log(this.notesDetail)
      }).catch(err => {
        this.$message.error(err || '获取报名记录详情失败')
      })
    },
    getUserDetail (val) {
      this.$store.dispatch('getReadPeopleDetail', val).then(res => {
        this.userDetail = res
      }).catch(err => {
        this.$message.error(err || '获取解读师详情失败')
      })
    }
  },
  created () {
    if (this.recordId !== '0') {
      this.signNotesDetail()
    }
  }
}
</script>
